<template>
  <v-container fluid class="assessores-page pa-4 pa-md-6">
    <!-- Filtros -->
    <v-card outlined class="filter-card mb-6">
      <div class="pa-4">
        <v-row align="center">
          <v-col cols="12" sm="auto" class="d-flex align-center pb-0 pb-sm-3">
            <v-icon color="grey" size="22" class="mr-2">mdi-filter-variant</v-icon>
            <span class="subtitle-2 grey--text text--darken-1 font-weight-bold">Filtros</span>
          </v-col>
          <v-col cols="12" sm="3" class="pb-0 pb-sm-3">
            <v-select
              v-model="select_equipe"
              :items="selects.candidatos.items"
              :disabled="selects.candidatos.ativado"
              @change="onEquipeChange()"
              outlined
              dense
              label="Equipe"
              item-value="idcandidato"
              item-text="nome_completo"
              prepend-inner-icon="mdi-account-group"
              class="styled-select"
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" sm="3" class="pb-0 pb-sm-3">
            <v-select
              v-model="select_meta"
              :items="metasFiltroComTodos"
              outlined
              dense
              label="Tipo de Meta"
              item-value="idmeta"
              item-text="descricao"
              prepend-inner-icon="mdi-target"
              class="styled-select"
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" sm="auto" class="pb-0 pb-sm-3">
            <v-btn
              color="primary"
              depressed
              class="btn-novo"
              @click="getAssessor(select_equipe)"
            >
              <v-icon left small>mdi-magnify</v-icon>
              Buscar
            </v-btn>
          </v-col>
          <v-col cols="12" sm="auto" class="pb-0 pb-sm-3">
            <v-btn
              color="warning"
              depressed
              class="btn-novo"
              @click="RelatorioAssessor(select_equipe, select_meta)"
            >
              <v-icon left small>mdi-file-chart</v-icon>
              Relatório
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-card>

    <!-- Tabela -->
    <v-card outlined class="table-card">
      <v-data-table
        :loading="filtrando"
        loading-text="Filtrando..."
        :headers="headers"
        :items="filteredDesserts"
        height="70vh"
        :fixed-header="true"
        :items-per-page="100"
        :footer-props="{
          itemsPerPageOptions: [50, 100, 200, 500, -1],
          'items-per-page-text': 'Itens por página',
        }"
        :search="search"
        class="modern-table"
      >
        <template v-slot:top>
          <div class="table-header pa-4 pb-2">
            <v-row align="center">
              <v-col cols="12" sm="6" class="d-flex align-center">
                <v-icon color="grey" size="28" class="mr-3">mdi-account-star</v-icon>
                <div>
                  <div class="title font-weight-bold" style="color: #757575">Cadastro de Assessores</div>
                  <div class="caption grey--text">
                    {{ filteredDesserts.length }} assessor{{ filteredDesserts.length !== 1 ? 'es' : '' }} cadastrado{{ filteredDesserts.length !== 1 ? 's' : '' }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6" class="d-flex align-center justify-sm-end">
                <v-text-field
                  @input="onSearchInput"
                  outlined
                  dense
                  prepend-inner-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                  class="styled-input mr-3"
                  style="max-width: 280px"
                ></v-text-field>
                <v-btn
                  color="primary"
                  dark
                  depressed
                  class="btn-novo"
                  @click="openNew()"
                >
                  <v-icon left small>mdi-plus</v-icon>
                  Novo
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </template>

        <!-- Coluna Atuação -->
        <template v-slot:item.tipo_atuacao="{ item }">
          <v-chip
            v-if="item.tipo_atuacao"
            small
            label
            :color="atuacaoBg(item.tipo_atuacao)"
            :text-color="atuacaoCor(item.tipo_atuacao)"
          >
            {{ atuacaoLabel(item.tipo_atuacao) }}
          </v-chip>
          <span v-else class="grey--text">—</span>
          <v-chip
            v-if="item.tipo_assessor === 'acs'"
            small
            label
            color="#FFF3E0"
            text-color="#E65100"
            class="ml-1"
          >
            ACS
          </v-chip>
        </template>

        <!-- Coluna Equipes (vínculos N:M — um assessor pode atender mais de uma) -->
        <template v-slot:item.equipes_label="{ item }">
          <div
            v-for="equipes in [equipesDoAssessor(item)]"
            :key="equipes.length"
            class="equipes-cell"
          >
            <v-chip
              v-for="c in equipes"
              :key="c.idcandidato"
              x-small
              class="ma-1"
              :color="equipeEmFoco(c) ? 'green' : 'amber darken-2'"
              text-color="white"
            >
              {{ c.name }}
            </v-chip>
            <span v-if="!equipes.length" class="grey--text">—</span>
          </div>
        </template>

        <!-- Coluna Ações -->
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon small class="action-icon-btn mr-1" v-on="on" @click="editItem(item)">
                <v-icon small color="grey">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar Assessor</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon small class="action-icon-btn mr-1" v-on="on" @click="refreshPassword(item)">
                <v-icon small color="orange">mdi-lock-reset</v-icon>
              </v-btn>
            </template>
            <span>Resetar Senha</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon small class="action-icon-btn" v-on="on" @click="deleteItem(item)">
                <v-icon small color="red lighten-1">mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Remover Assessor</span>
          </v-tooltip>
        </template>

        <!-- Empty state -->
        <template v-slot:no-data>
          <div class="text-center pa-10">
            <v-icon size="64" color="grey lighten-2" class="mb-4">mdi-account-star</v-icon>
            <div class="subtitle-1 grey--text text--darken-1 mb-2">Nenhum assessor cadastrado</div>
            <div class="body-2 grey--text">Clique em "Novo" para cadastrar um assessor</div>
          </div>
        </template>

        <!-- No results state -->
        <template v-slot:no-results>
          <div class="text-center pa-10">
            <v-icon size="64" color="grey lighten-2" class="mb-4">mdi-magnify-close</v-icon>
            <div class="subtitle-1 grey--text text--darken-1 mb-2">Nenhum resultado encontrado</div>
            <div class="body-2 grey--text">Tente uma pesquisa diferente</div>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- Dialog -->
    <v-dialog
      persistent
      v-model="dialog"
      fullscreen
      scrollable
      transition="dialog-bottom-transition"
    >
      <v-card class="dialog-card">
        <v-card-title class="dialog-header pa-4">
          <v-icon color="grey" class="mr-3">{{ editedIndex === -1 ? 'mdi-account-plus' : 'mdi-pencil' }}</v-icon>
          <span class="title font-weight-bold" style="color: #757575">{{ formTitle }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-6 dialog-body">
          <v-row class="dialog-content-wrap">
            <!-- ========== COLUNA ESQUERDA: Dados pessoais + Acesso ========== -->
            <v-col cols="12" md="6" class="py-0">
              <v-row>
            <!-- ===== Seção: Dados pessoais ===== -->
            <v-col cols="12" class="py-0">
              <div class="section-title">
                <v-icon small color="#0E314A" class="mr-2">mdi-account-circle-outline</v-icon>
                Dados pessoais
              </div>
            </v-col>

            <v-col cols="12" class="pb-1">
              <v-text-field
                outlined
                dense
                v-model="editedItem.name"
                counter
                label="Nome Completo*"
                autofocus
                prepend-inner-icon="mdi-account"
                class="styled-input"
                :error-messages="nameErrors"
                @input="$v.editedItem.name.$touch()"
                @blur="$v.editedItem.name.$touch()"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="pb-1">
              <v-text-field
                outlined
                dense
                v-model="editedItem.email"
                label="Email*"
                prepend-inner-icon="mdi-email-outline"
                class="styled-input"
                :error-messages="emailErrors"
                @input="$v.editedItem.email.$touch()"
                @blur="$v.editedItem.email.$touch()"
              ></v-text-field>
            </v-col>
            <v-col v-if="editedItem.idperfil != 3" cols="12" sm="6" class="pb-1">
              <v-select
                v-model="editedItem.tipo_assessor"
                :items="tipos_assessor"
                outlined
                dense
                label="Tipo de assessor"
                prepend-inner-icon="mdi-account-badge-outline"
                class="styled-select"
                hint="ACS/Casinha: CPF e telefone opcionais; o telefone das pessoas pode repetir"
                :persistent-hint="ehAcs"
                @change="tocarContato()"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" class="pb-1">
              <v-text-field
                outlined
                dense
                v-model="editedItem.cpf"
                :label="ehAcs ? 'CPF' : 'CPF*'"
                prepend-inner-icon="mdi-card-account-details"
                class="styled-input"
                v-mask="'###.###.###-##'"
                :error-messages="cpfErrors"
                @input="$v.editedItem.cpf.$touch()"
                @blur="$v.editedItem.cpf.$touch()"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="pb-1">
              <v-text-field
                outlined
                dense
                v-model="editedItem.telefone"
                :label="ehAcs ? 'Telefone' : 'Telefone*'"
                prepend-inner-icon="mdi-phone"
                class="styled-input"
                v-mask="'(##) #####-####'"
                :error-messages="telefoneErrors"
                @input="$v.editedItem.telefone.$touch()"
                @blur="$v.editedItem.telefone.$touch()"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="pb-1">
              <v-select
                v-model="editedItem.idperfil"
                :items="selects.perfil.items"
                @change="clearMeta(editedItem.idperfil)"
                outlined
                dense
                label="Perfil do Sistema"
                item-value="idperfil"
                item-text="descricao_perfil"
                prepend-inner-icon="mdi-shield-account"
                class="styled-select"
                :error-messages="perfilErrors"
                @input="$v.editedItem.idperfil.$touch()"
                @blur="$v.editedItem.idperfil.$touch()"
              ></v-select>
            </v-col>

            <!-- ===== Seção: Acesso (apenas na criação) ===== -->
            <v-col v-if="editedIndex === -1" cols="12" class="py-0">
              <v-divider class="section-divider"></v-divider>
              <div class="section-title">
                <v-icon small color="#0E314A" class="mr-2">mdi-lock-outline</v-icon>
                Acesso
              </div>
            </v-col>
            <v-col
              v-if="editedIndex === -1"
              cols="12"
              sm="6"
              class="pb-1"
            >
              <v-text-field
                outlined
                dense
                v-model="editedItem.password"
                label="Nova Senha*"
                prepend-inner-icon="mdi-lock"
                class="styled-input"
                type="password"
                autocomplete="new-password"
                :error-messages="passwordErrors"
                @input="$v.editedItem.password.$touch()"
                @blur="$v.editedItem.password.$touch()"
              ></v-text-field>
            </v-col>
            <v-col
              v-if="editedIndex === -1"
              cols="12"
              sm="6"
              class="pb-1"
            >
              <v-text-field
                outlined
                dense
                v-model="editedItem.repeatPassword"
                label="Confirma Senha*"
                prepend-inner-icon="mdi-lock-check"
                class="styled-input"
                type="password"
                :error-messages="repeatPasswordErrors"
                @input="$v.editedItem.repeatPassword.$touch()"
                @blur="$v.editedItem.repeatPassword.$touch()"
              ></v-text-field>
            </v-col>

              </v-row>
            </v-col>

            <!-- ========== COLUNA DIREITA: Atuação + Vínculos ========== -->
            <v-col cols="12" md="6" class="py-0">
              <v-row>
            <!-- ===== Seção: Atuação ===== -->
            <v-col v-show="editedItem.idperfil != 4" cols="12" class="py-0">
              <div class="section-title">
                <v-icon small color="#0E314A" class="mr-2">mdi-map-marker-radius-outline</v-icon>
                Atuação
              </div>

              <div class="atuacao-box">
                <v-row class="ma-0">
                  <v-col cols="12" sm="6" class="pb-1">
                    <v-select
                      v-model="editedItem.tipo_atuacao"
                      :items="tipos_atuacao"
                      outlined
                      dense
                      label="Atuação*"
                      item-text="text"
                      item-value="value"
                      prepend-inner-icon="mdi-map-marker-radius"
                      class="styled-select"
                      :error-messages="tipoAtuacaoErrors"
                      @input="$v.editedItem.tipo_atuacao.$touch()"
                      @blur="$v.editedItem.tipo_atuacao.$touch()"
                    ></v-select>
                  </v-col>

                  <v-col
                    v-show="
                      editedItem.idperfil != 4 &&
                      (editedItem.tipo_atuacao === 'capital' ||
                        editedItem.tipo_atuacao === 'ambos')
                    "
                    cols="12"
                    class="pb-1"
                  >
                    <v-select
                      v-model="editedItem.zonas_geograficas"
                      :items="selects.zonas_geograficas.items"
                      outlined
                      dense
                      multiple
                      chips
                      small-chips
                      deletable-chips
                      label="Zonas geográficas (Capital)*"
                      item-text="nome"
                      item-value="id"
                      prepend-inner-icon="mdi-compass-outline"
                      class="styled-select"
                      :error-messages="zonasGeograficasErrors"
                      @input="$v.editedItem.zonas_geograficas.$touch()"
                      @blur="$v.editedItem.zonas_geograficas.$touch()"
                    ></v-select>
                  </v-col>

                  <v-col
                    v-show="
                      editedItem.idperfil != 4 &&
                      (editedItem.tipo_atuacao === 'interior' ||
                        editedItem.tipo_atuacao === 'ambos')
                    "
                    cols="12"
                    class="pb-1"
                  >
                    <v-autocomplete
                      v-model="editedItem.municipios"
                      :items="selects.municipios.items"
                      outlined
                      dense
                      multiple
                      chips
                      small-chips
                      deletable-chips
                      clearable
                      label="Municípios (Interior — AM)*"
                      placeholder="Digite para buscar um município..."
                      no-data-text="Nenhum município encontrado"
                      item-text="nome"
                      item-value="id"
                      prepend-inner-icon="mdi-city-variant-outline"
                      class="styled-select"
                      :error-messages="municipiosErrors"
                      @input="$v.editedItem.municipios.$touch()"
                      @blur="$v.editedItem.municipios.$touch()"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </div>
            </v-col>

            <!-- ===== Seção: Vínculos ===== -->
            <v-col v-show="editedItem.idperfil != 4" cols="12" class="py-0">
              <v-divider class="section-divider"></v-divider>
              <div class="section-title d-flex align-center">
                <v-icon small color="#0E314A" class="mr-2">mdi-link-variant</v-icon>
                Vínculos (candidato + meta)
                <v-spacer></v-spacer>
                <v-btn
                  small
                  text
                  color="primary"
                  :disabled="selects.candidatos.ativado && editedItem.vinculos.length >= 1"
                  @click="addVinculo"
                >
                  <v-icon left small>mdi-plus</v-icon>
                  Adicionar candidato
                </v-btn>
              </div>

              <div
                v-for="(vinc, i) in editedItem.vinculos"
                :key="i"
                class="vinculo-row"
              >
                <v-row class="ma-0" align="center">
                  <v-col cols="12" sm="6" class="pa-1">
                    <v-select
                      v-model="vinc.idcandidato"
                      :items="selects.candidatos.items"
                      :disabled="selects.candidatos.ativado || vinculoBloqueado(vinc)"
                      outlined
                      dense
                      hide-details
                      label="Candidato"
                      item-value="idcandidato"
                      item-text="nome_completo"
                      prepend-inner-icon="mdi-account-group"
                      class="styled-select"
                      @change="vinc.idmeta = null"
                    ></v-select>
                  </v-col>
                  <v-col cols="10" sm="5" class="pa-1">
                    <v-select
                      v-model="vinc.idmeta"
                      :items="metasDoCandidato(vinc.idcandidato)"
                      outlined
                      dense
                      hide-details
                      label="Meta"
                      item-value="idmeta"
                      item-text="descricao"
                      prepend-inner-icon="mdi-target"
                      class="styled-select"
                    ></v-select>
                  </v-col>
                  <v-col cols="2" sm="1" class="pa-1 d-flex align-center justify-center">
                    <v-tooltip top :disabled="!vinculoBloqueado(vinc)">
                      <template #activator="{ on, attrs }">
                        <div v-on="on" v-bind="attrs">
                          <v-btn
                            icon
                            small
                            color="error"
                            :disabled="vinculoBloqueado(vinc)"
                            @click="removeVinculo(i)"
                          >
                            <v-icon small>mdi-delete</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      <span>
                        Este candidato já possui {{ vinc.total_cadastrado }}
                        cadastro(s) feito(s) por este assessor. Não é possível
                        remover ou trocar o vínculo — procure o administrador do
                        sistema.
                      </span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>

              <div
                v-if="!editedItem.vinculos || editedItem.vinculos.length === 0"
                class="caption error--text mt-1"
              >
                Adicione ao menos um candidato.
              </div>
            </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn outlined class="btn-action mr-2" @click="close">
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-btn depressed dark color="primary" class="btn-action" @click="save">
            <v-icon left small>mdi-check</v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import {
  required,
  requiredIf,
  email,
  sameAs,
  minLength,
} from "vuelidate/lib/validators";
import UsuarioAPI from "./../../api/usuario";
import AclAPI from "./../../api/acl";
import { validarCPF } from "./../../helpers";

export default {
  props: ["atualizarUsu"],
  name: "Acl",
  data: () => ({
    dialog: false,
    search: "",
    searchDebounce: null,
    headers: [
      {
        text: "ID",
        value: "id",
      },
      {
        text: "Nome Completo",
        align: "left",
        value: "name",
      },
      { text: "Email", value: "email" },
      { text: "CPF", value: "cpf" },
      { text: "Telefone", value: "telefone" },
      { text: "Perfil", value: "descricao_perfil" },
      { text: "Atuação", value: "tipo_atuacao" },
      { text: "Equipes", value: "equipes_label" },
      { text: "Ações", value: "action", sortable: false },
    ],
    desserts: [],
    editedIndex: -1,
    select_equipe: 0,
    select_meta: 0,
    filtrando: false,
    selects: {
      perfil: {
        items: [],
      },
      candidatos: {
        ativado: false,
        items: [],
      },
      metas: {
        items: [],
      },
      todas_metas: {
        items: [],
      },
      zonas_geograficas: {
        items: [],
      },
      municipios: {
        items: [],
      },
    },
    tipos_assessor: [
      { text: "Padrão", value: "padrao" },
      { text: "ACS/Casinha", value: "acs" },
    ],
    tipos_atuacao: [
      { text: "Capital", value: "capital" },
      { text: "Interior", value: "interior" },
      { text: "Ambos", value: "ambos" },
    ],
    editedItem: {
      id: "",
      name: "",
      email: "",
      cpf: "",
      telefone: "",
      idperfil: "",
      password: "",
      repeatPassword: "",
      idgerente: "",
      idmeta: "",
      vinculos: [],
      tipo_atuacao: "",
      tipo_assessor: "padrao",
      zonas_geograficas: [],
      municipios: [],
    },
    defaultItem: {
      id: "",
      name: "",
      email: "",
      cpf: "",
      telefone: "",
      idperfil: "",
      password: "",
      repeatPassword: "",
      idgerente: "",
      idmeta: "",
      vinculos: [],
      tipo_atuacao: "",
      tipo_assessor: "padrao",
      zonas_geograficas: [],
      municipios: [],
    },
  }),

  validations: {
    editedItem: {
      name: {
        required,
        minLength: minLength(4),
      },
      email: {
        required,
        email,
      },
      cpf: {
        // ACS/Casinha tem CPF opcional; quando preenchido, continua validado.
        required: requiredIf(function () {
          return !this.ehAcs;
        }),
        cpfValido: (v) => !v || validarCPF(v),
      },
      telefone: {
        // ACS/Casinha tambem nao precisa informar telefone.
        required: requiredIf(function () {
          return !this.ehAcs;
        }),
      },
      idperfil: {
        required,
      },
      password: {
        required,
        minLength: minLength(4),
      },
      vinculos: {
        pelomenosUm: (v) => Array.isArray(v) && v.some((x) => x.idcandidato),
      },
      repeatPassword: {
        sameAsPassword: sameAs("password"),
      },
      tipo_atuacao: {
        required,
      },
      zonas_geograficas: {
        pelomenosUma(v) {
          const tipo = this.editedItem.tipo_atuacao;
          if (tipo !== "capital" && tipo !== "ambos") return true;
          return Array.isArray(v) && v.length > 0;
        },
      },
      municipios: {
        pelomenosUm(v) {
          const tipo = this.editedItem.tipo_atuacao;
          if (tipo !== "interior" && tipo !== "ambos") return true;
          return Array.isArray(v) && v.length > 0;
        },
      },
    },
  },

  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.editedItem.name.$dirty) return errors;
      !this.$v.editedItem.name.required && errors.push("Campo Obrigatório.");
      !this.$v.editedItem.name.minLength &&
        errors.push("A Nome Completo  dever ser maior que 4 caracteres");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.editedItem.email.$dirty) return errors;
      !this.$v.editedItem.email.email && errors.push("Email incorreto.");
      !this.$v.editedItem.email.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    // ACS/casinha: CPF e telefone do assessor ficam opcionais.
    ehAcs() {
      return (
        this.editedItem.idperfil != 3 && this.editedItem.tipo_assessor === "acs"
      );
    },
    cpfErrors() {
      const errors = [];
      if (!this.$v.editedItem.cpf.$dirty) return errors;
      !this.$v.editedItem.cpf.required && errors.push("CPF é obrigatório.");
      !this.$v.editedItem.cpf.cpfValido && errors.push("CPF inválido.");
      return errors;
    },
    telefoneErrors() {
      const errors = [];
      if (!this.$v.editedItem.telefone.$dirty) return errors;
      !this.$v.editedItem.telefone.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    perfilErrors() {
      const errors = [];
      if (!this.$v.editedItem.idperfil.$dirty) return errors;
      !this.$v.editedItem.idperfil.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    vinculosErrors() {
      const errors = [];
      if (!this.$v.editedItem.vinculos.$dirty) return errors;
      !this.$v.editedItem.vinculos.pelomenosUm &&
        errors.push("Adicione ao menos um candidato.");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.editedItem.password.$dirty) return errors;
      !this.$v.editedItem.password.minLength &&
        errors.push("A senha dever ser maior que 4 caracteres");
      !this.$v.editedItem.password.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    repeatPasswordErrors() {
      const errors = [];
      if (!this.$v.editedItem.repeatPassword.$dirty) return errors;
      !this.$v.editedItem.repeatPassword.sameAsPassword &&
        errors.push("As senhas devem ser iguais.");
      return errors;
    },
    tipoAtuacaoErrors() {
      const errors = [];
      if (!this.$v.editedItem.tipo_atuacao.$dirty) return errors;
      !this.$v.editedItem.tipo_atuacao.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    zonasGeograficasErrors() {
      const errors = [];
      if (!this.$v.editedItem.zonas_geograficas.$dirty) return errors;
      !this.$v.editedItem.zonas_geograficas.pelomenosUma &&
        errors.push("Selecione ao menos uma zona geográfica.");
      return errors;
    },
    municipiosErrors() {
      const errors = [];
      if (!this.$v.editedItem.municipios.$dirty) return errors;
      !this.$v.editedItem.municipios.pelomenosUm &&
        errors.push("Selecione ao menos um município.");
      return errors;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Novo Assessor" : "Editar Assessor";
    },
    metasFiltroComTodos() {
      return [{ idmeta: 0, descricao: 'Todos' }, ...this.selects.metas.items];
    },
    filteredDesserts() {
      if (!this.select_meta) return this.desserts;
      return this.desserts.filter(a => this.idmetasDoAssessor(a).includes(this.select_meta));
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    select_meta() {
      this.filtrando = true;
      setTimeout(() => {
        this.filtrando = false;
      }, 400);
    },

    atualizarUsu() {
      this.initialize();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    // Sem v-model de propósito: o campo fica no slot top da tabela e um dado
    // reativo aqui redesenharia todas as linhas a cada tecla.
    onSearchInput(val) {
      clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => {
        this.search = val;
      }, 300);
    },

    initialize() {
      const headers = this.Helpers.iniciarRequisicao();
      //Filtro Usuarios da Equipe caso tenha
      const equipe = localStorage.getItem("equipe");

      const params = {
        equipe: equipe,
        assessor: 1,
      };

      if (equipe != "null") {
        this.select_equipe = parseInt(equipe);
        this.selects.candidatos.ativado = true;
        this.getMetas(equipe);
      }

      this.getTodasMetas();

      UsuarioAPI.getPerfis(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (response.status == 200) {
            this.selects.perfil.items = response.data.perfis;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });

      AclAPI.getCandidatos(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (response.status == 200) {
            this.selects.candidatos.items = response.data.candidatos;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });

      AclAPI.getZonasGeograficas(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (response.status == 200) {
            this.selects.zonas_geograficas.items =
              response.data.zonas_geograficas;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });

      AclAPI.getMunicipios(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (response.status == 200) {
            this.selects.municipios.items = response.data.municipios;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });

      this.$store.dispatch(
        "loading/addRequisicao",

        UsuarioAPI.getUsuarios(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              this.setDesserts(response.data.usuarios);
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
    getAssessor(equipe) {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        equipe: equipe,
        assessor: 1,
      };

      this.$store.dispatch(
        "loading/addRequisicao",

        UsuarioAPI.getUsuarios(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              this.setDesserts(response.data.usuarios);
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
    getMetas(equipe) {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        equipe: equipe,
      };

      AclAPI.getMetas(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.selects.metas.items = [];

          if (response.status == 200) {
            this.selects.metas.items = response.data.metas;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },
    onEquipeChange() {
      // A meta selecionada pertence a equipe anterior; zera para nao esvaziar a tabela.
      this.select_meta = 0;
      this.getMetas(this.select_equipe);
      this.getAssessor(this.select_equipe);
    },

    // Anexa as equipes do assessor (vinculos N:M) em cada linha da tabela.
    // Muta o proprio objeto de propósito: editItem() localiza a linha por
    // desserts.indexOf(item), entao a identidade precisa ser preservada.
    setDesserts(usuarios) {
      this.desserts = (usuarios || []).map((u) => {
        const vinculos = Array.isArray(u.vinculos) ? u.vinculos : [];

        u.equipes = vinculos
          .filter((v) => v.candidato_nome)
          .map((v) => ({ idcandidato: v.idcandidato, name: v.candidato_nome }));
        u.equipes_label = u.equipes.map((e) => e.name).join(", ");

        return u;
      });
    },

    // Equipes exibidas na tabela, com a equipe filtrada em primeiro lugar
    // (mesmo padrao visual do cadastro de pessoas). Cai para o vinculo primario
    // legado (users.idgerente) apenas em cadastros antigos, sem vinculos.
    equipesDoAssessor(assessor) {
      const equipes = Array.isArray(assessor.equipes) ? assessor.equipes : [];

      if (!equipes.length) {
        if (!assessor.idgerente) return [];

        const candidato = (this.selects.candidatos.items || []).find(
          (c) => String(c.idcandidato) === String(assessor.idgerente)
        );

        return candidato
          ? [{ idcandidato: candidato.idcandidato, name: candidato.nome_completo }]
          : [];
      }

      if (!this.select_equipe) return equipes;

      return [...equipes].sort((a, b) => {
        if (this.equipeEmFoco(a)) return -1;
        if (this.equipeEmFoco(b)) return 1;
        return 0;
      });
    },

    equipeEmFoco(equipe) {
      return (
        !!this.select_equipe &&
        String(equipe.idcandidato) === String(this.select_equipe)
      );
    },

    // Metas do assessor no escopo da equipe filtrada. A fonte de verdade sao os
    // vinculos N:M (assessor_candidato); users.idmeta e' apenas fallback legado,
    // pois guarda somente o vinculo primario.
    idmetasDoAssessor(assessor) {
      const vinculos = Array.isArray(assessor.vinculos) ? assessor.vinculos : [];

      if (!vinculos.length) return assessor.idmeta ? [Number(assessor.idmeta)] : [];

      return vinculos
        .filter((v) => !this.select_equipe || String(v.idcandidato) === String(this.select_equipe))
        .map((v) => Number(v.idmeta))
        .filter((id) => id);
    },

    // Carrega TODAS as metas (de todos os candidatos) para filtrar por candidato no dialog de vinculos.
    getTodasMetas() {
      const headers = this.Helpers.iniciarRequisicao();
      AclAPI.getMetas(headers, {})
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);
          if (response.status == 200) {
            this.selects.todas_metas.items = response.data.metas || [];
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },

    metasDoCandidato(idcandidato) {
      if (!idcandidato) return [];
      return (this.selects.todas_metas.items || []).filter(
        (m) => String(m.idcandidato) === String(idcandidato)
      );
    },

    addVinculo() {
      if (!Array.isArray(this.editedItem.vinculos)) {
        this.$set(this.editedItem, "vinculos", []);
      }
      this.editedItem.vinculos.push({ idcandidato: null, idmeta: null, total_cadastrado: 0 });
      this.$v.editedItem.vinculos.$touch();
    },

    // Um vinculo com pessoas ja cadastradas para aquele assessor+candidato nao
    // pode ser removido nem ter o candidato trocado (orfanaria os cadastros).
    vinculoBloqueado(vinc) {
      return !!vinc && Number(vinc.total_cadastrado) > 0;
    },

    removeVinculo(i) {
      if (this.vinculoBloqueado(this.editedItem.vinculos[i])) {
        return;
      }
      this.editedItem.vinculos.splice(i, 1);
      this.$v.editedItem.vinculos.$touch();
    },

    openNew() {
      this.setEquipe();
      this.dialog = true;
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);

      // Reconstroi a lista de vinculos a partir do retorno do backend (item.vinculos).
      const vinc = Array.isArray(item.vinculos) ? item.vinculos : [];
      this.$set(
        this.editedItem,
        "vinculos",
        vinc.map((v) => ({
          idcandidato: v.idcandidato,
          idmeta: v.idmeta,
          total_cadastrado: Number(v.total_cadastrado) || 0,
        }))
      );

      // Fallback: assessor antigo sem linha de vinculo, usa o par legado.
      if (this.editedItem.vinculos.length === 0 && item.idgerente) {
        this.editedItem.vinculos = [
          { idcandidato: item.idgerente, idmeta: item.idmeta || null, total_cadastrado: 0 },
        ];
      }

      // Atuacao geografica: copia em arrays novos (evita compartilhar referencia com a linha da tabela).
      this.$set(this.editedItem, "tipo_atuacao", item.tipo_atuacao || "");
      this.$set(this.editedItem, "tipo_assessor", item.tipo_assessor || "padrao");
      this.$set(
        this.editedItem,
        "zonas_geograficas",
        Array.isArray(item.zonas_geograficas) ? [...item.zonas_geograficas] : []
      );
      this.$set(
        this.editedItem,
        "municipios",
        Array.isArray(item.municipios) ? [...item.municipios] : []
      );

      this.getTodasMetas();
      this.dialog = true;
    },

    refreshPassword(item) {
      if (
        confirm("Deseja redefinir a senha do Assessor? Senha Padrão: 123456")
      ) {
        this.editedItem = Object.assign({}, item);

        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          UsuarioAPI.resetPassword(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.editedItem = {};
                this.initialize();
              }
            })
            .catch(() => {
              alert("Falha na operação registro possui vínculos!!!");
            })
        );
      } else {
        this.editedItem = {};
      }
    },

    deleteItem(item) {
      this.editedItem = Object.assign({}, item);

      if (confirm("Deseja remover Assessor?")) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          UsuarioAPI.deletar(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.editedItem = {};
                this.initialize();
              }
            })
            .catch(() => {
              alert("Falha na operação registro possui vínculos!!!");
            })
        );
      } else {
        this.editedItem = {};
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    // Trocar o tipo muda a obrigatoriedade de CPF e telefone: revalida os dois.
    tocarContato() {
      this.$v.editedItem.cpf.$touch();
      this.$v.editedItem.telefone.$touch();
    },
    clearMeta(id) {
      if (id == 4) {
        this.editedItem.idmeta = null;
      }
    },

    // Rótulo e cor da coluna "Atuação" na tabela (reusa tipos_atuacao para o texto).
    atuacaoLabel(t) {
      const opt = this.tipos_atuacao.find((x) => x.value === t);
      return opt ? opt.text : "—";
    },
    // Texto colorido por tipo (tom forte)
    atuacaoCor(t) {
      return (
        { capital: "#0E314A", interior: "#2E7D32", ambos: "#455A64" }[t] ||
        "grey"
      );
    },
    // Fundo claro correspondente (tom suave)
    atuacaoBg(t) {
      return (
        { capital: "#E3EAF0", interior: "#E6F0E7", ambos: "#ECEFF1" }[t] ||
        "#EEEEEE"
      );
    },

    save() {
      if (this.editedItem.id > 0) {
        this.editedItem.repeatPassword = this.editedItem.password;
      }

      // Limpa vinculos sem candidato e espelha o vinculo primario nos campos legados.
      const vinculos = (this.editedItem.vinculos || []).filter(
        (v) => v.idcandidato
      );
      this.editedItem.vinculos = vinculos;
      if (vinculos.length > 0) {
        this.editedItem.idgerente = vinculos[0].idcandidato;
        this.editedItem.idmeta = vinculos[0].idmeta || null;
      }

      // Atuacao geografica: descarta o conjunto que nao se aplica ao tipo escolhido.
      const tipo = this.editedItem.tipo_atuacao;
      if (tipo !== "capital" && tipo !== "ambos") {
        this.editedItem.zonas_geograficas = [];
      }
      if (tipo !== "interior" && tipo !== "ambos") {
        this.editedItem.municipios = [];
      }

      this.$v.$touch();

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          UsuarioAPI.salvar(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.initialize();
              }
            })
            .catch((error) => {
              const err = error.response && error.response.data && error.response.data.error;
              if (err === "cpf_obrigatorio") {
                alert("CPF é obrigatório para assessor do tipo Padrão.");
              } else {
                alert("Falha na operação!!!");
              }
            })
        );

        this.close();
      }
    },
    setEquipe() {
      const equipe = localStorage.getItem("equipe");

      if (equipe != "null") {
        // Candidato fixo (usuario nao-admin): inicia com um unico vinculo travado.
        this.selects.candidatos.ativado = true;
        this.$set(this.editedItem, "vinculos", [
          { idcandidato: parseInt(equipe), idmeta: null },
        ]);
        this.getTodasMetas();
      }
    },
    RelatorioAssessor(equipe, meta) {
      let url =
        "relatorio_analitico_assessores?equipe=" + equipe + "&meta=" + meta;
      window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
    },
  },
};
</script>
<style scoped>
.assessores-page {
  animation: fadeInUp 0.4s ease-out;
}

/* --- Cards --- */
.filter-card {
  border-radius: 16px !important;
  border-color: rgba(0, 0, 0, 0.08) !important;
  background: #fafbfc;
}

.table-card {
  border-radius: 16px !important;
  border-color: rgba(0, 0, 0, 0.08) !important;
  overflow: hidden;
}

/* --- Selects e Inputs estilizados --- */
.styled-select >>> .v-input__slot,
.styled-input >>> .v-input__slot {
  border-radius: 12px !important;
  min-height: 40px !important;
}

.styled-select >>> fieldset,
.styled-input >>> fieldset {
  border-color: rgba(0, 0, 0, 0.12);
  transition: border-color 0.2s ease;
}

.styled-select >>> .v-input--is-focused fieldset,
.styled-input >>> .v-input--is-focused fieldset {
  border-color: #216b80 !important;
  border-width: 2px;
}

/* --- Botões --- */
.btn-novo {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600;
  letter-spacing: 0.3px;
  transition: all 0.2s ease;
}

.btn-novo:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(33, 107, 128, 0.3) !important;
}

.btn-action {
  border-radius: 10px !important;
  text-transform: none !important;
  font-weight: 600;
  letter-spacing: 0.3px;
  min-width: 120px !important;
}

.action-icon-btn {
  transition: all 0.2s ease;
}

.action-icon-btn:hover {
  background: rgba(33, 107, 128, 0.08) !important;
  transform: scale(1.1);
}

/* --- Tabela --- */
.table-header {
  background: #fafbfc;
}

.modern-table >>> .v-data-table-header th {
  background: #f5f7fa !important;
  color: #5a6a7e !important;
  font-weight: 600 !important;
  font-size: 0.75rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
  border-bottom: 2px solid rgba(0, 0, 0, 0.08) !important;
}

.modern-table >>> .v-data-table-header th .v-icon {
  color: #5a6a7e !important;
}

.modern-table >>> tbody tr {
  transition: background-color 0.15s ease;
}

.modern-table >>> tbody tr:hover {
  background-color: rgba(33, 107, 128, 0.04) !important;
}

.modern-table >>> tbody td {
  font-size: 0.85rem !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06) !important;
}

.modern-table >>> .v-data-footer {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

/* Chips de equipe: assessor com mais de um vinculo quebra em varias linhas. */
.equipes-cell {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-width: 120px;
}

/* --- Dialog (fullscreen) --- */
.dialog-card {
  border-radius: 0 !important;
  overflow: hidden;
}

.dialog-header {
  background: #ffffff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

/* Corpo preenche a altura entre header e footer fixos; rola só se precisar */
.dialog-body {
  overflow-y: auto;
}

/* Centraliza o formulário e limita a largura útil em telas grandes.
   Layout em 2 colunas (Dados/Acesso | Atuação/Vínculos) aproveita a largura
   do fullscreen e reduz a altura, evitando rolagem vertical. */
.dialog-content-wrap {
  max-width: 1320px;
  margin: 0 auto;
  width: 100%;
}

/* Separa visualmente as duas colunas em telas largas */
@media (min-width: 960px) {
  .dialog-content-wrap > .col-md-6:first-child {
    border-right: 1px solid rgba(14, 49, 74, 0.08);
  }
}

/* --- Seções do formulário --- */
.section-title {
  display: flex;
  align-items: center;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #0e314a;
  margin: 4px 0 10px;
}

.section-divider {
  margin: 8px 0 16px;
  border-color: rgba(14, 49, 74, 0.1) !important;
}

/* Caixa destacada da seção condicional de Atuação */
.atuacao-box {
  background: rgba(14, 49, 74, 0.035);
  border: 1px solid rgba(14, 49, 74, 0.1);
  border-radius: 14px;
  padding: 12px 12px 4px;
  margin-bottom: 4px;
}

/* Linha-cartão de cada vínculo candidato + meta */
.vinculo-row {
  background: #fafbfc;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  padding: 6px 8px;
  margin-bottom: 10px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.vinculo-row:hover {
  border-color: rgba(14, 49, 74, 0.18);
  box-shadow: 0 2px 8px rgba(14, 49, 74, 0.06);
}

/* --- Animação --- */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* --- Responsivo --- */
@media (max-width: 600px) {
  .assessores-page {
    padding: 8px !important;
  }

  .table-card {
    border-radius: 12px !important;
  }

  .btn-novo {
    width: 100%;
  }

  .atuacao-box {
    padding: 10px 8px 2px;
  }
}
</style>
